import React, {PropsWithChildren} from "react";
import {Link} from "react-router-dom";
import {ChevronLeftIcon} from "@heroicons/react/16/solid";


const PageHeader: React.FunctionComponent<PropsWithChildren<{link?: string, className?: string}>> = ({link, className = '',  children}) => {

    return <header className={`bg-white shadow-sm border-t border-gray-200 ${className}`}>
        <div className="mx-auto max-w-7xl py-4 px-4 sm:px-6 lg:px-8">
            <div className="flex items-center flex-wrap">
                {!!link && <Link to={link} className="btn btn-white rounded-full p-0.5 mr-3" title="Go back">
                    <ChevronLeftIcon className="h-4 w-4"/>
                </Link>}
                <div className="min-w-0 flex-1">
                    <h1 className="text-lg font-semibold leading-6 text-gray-900">{children}</h1>
                </div>
            </div>
        </div>
    </header>
}

export default PageHeader;